import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

import './Login.css';
import { EyeIcon, EyeOffIcon } from '../components/icons';

function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(null);
  const [rememberMe, setRememberMe] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return localStorage.getItem('rememberMe') === 'true';
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (name === 'password') {
      const passwordPattern = /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{6,}$/;
      setIsPasswordValid(passwordPattern.test(value));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      const res = await axios.post('http://localhost:5001/api/users/login', {
        email: form.email,
        password: form.password
      });

      if (rememberMe) {
        localStorage.setItem('rememberMe', 'true');
        localStorage.setItem('savedEmail', form.email);
      } else {
        localStorage.removeItem('rememberMe');
        localStorage.removeItem('savedEmail');
      }

      localStorage.setItem('token', res.data.token);
      setSuccess('Connexion réussie !');
      setTimeout(() => {
        navigate('/');
      }, 1000);
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors de la connexion");
    }
  };

  return (
    <div className="login-page">
      <div className="login-brand">Global Sourcing Solution Group</div>
      <div className="login-card">
        <div className="login-card__intro">
          <h2>Nouveau chez Global Sourcing Solution Group ?</h2>
          <p>Créez votre compte pour accéder à l'intégralité de notre sélection et suivre vos commandes.</p>
          <button type="button" className="login-btn login-btn--ghost" onClick={() => navigate('/register')}>
            S'inscrire
          </button>
        </div>
        <div className="login-card__form">
          <h2>Connexion</h2>
          <p className="login-subtitle">Connectez-vous pour gérer vos commandes et profiter de vos avantages professionnels.</p>
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-field">
              <label htmlFor="email">Adresse email</label>
              <input
                id="email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="login-field">
              <label htmlFor="password">Mot de passe</label>
              <div className="login-password-input">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  className={isPasswordValid === null ? '' : isPasswordValid ? 'is-valid' : 'is-invalid'}
                  required
                />
                <button
                  type="button"
                  className="login-password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-pressed={showPassword}
                  aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                >
                  {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>
            </div>
            <div className="login-remember-row">
              <label className="login-remember">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(event) => setRememberMe(event.target.checked)}
                />
                <span>Se souvenir de moi</span>
              </label>
              <div className="login-help">
                <Link to="/forgot-password" className="login-help__link">Mot de passe oublié ?</Link>
              </div>
            </div>
            <button type="submit" className="login-btn">Se connecter</button>
            {error && <p className="login-message login-message--error">{error}</p>}
            {success && <p className="login-message login-message--success">{success}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
